import { render } from "./SafetyTips.vue?vue&type=template&id=44854417"
const script = {}
script.render = render

export default script